import { useNavigate, useParams } from 'react-router-dom';
import TextWinds from '../../../components/common/TextWinds';
import Buttons from '../../../components/common/Buttons2';
import OrderInfo from '../../../components/mypage/purchase/OrderInfo';
import PaymentDetail from '../../../components/mypage/purchase/PaymentDetail';
import RefundCancelInfo from '../../../components/mypage/purchase/RefundCancelInfo';
import DeliveryInfo from '../../../components/mypage/purchase/DeliveryInfo';
import '../../../styles/mypage/mypage.css';
import { useAppDispatch, useAppSelector } from '../../../store/hook';
import {
  getMyOrderDetail,
  selectMyOrderDetail,
} from '../../../store/features/mySlice';
import { useContext, useEffect } from 'react';
import { openModal } from '../../../store/features/modalSlice';
import PurchaseReceipt from './PurchaseReceipt';
import { MypageContext } from '../membership/MypageContext';
import OrderIteminfo from '../../../components/mypage/purchase/OrderIteminfo';

const MypagePurchaseDetail = () => {
  const { userInfo } = useContext(MypageContext);
  const detailId = useParams().detailId;
  const navigate = useNavigate();
  const clickHandler = () => {
    navigate('/mypage/purchase');
  };

  const dispatch = useAppDispatch();
  const orderDetail = useAppSelector(selectMyOrderDetail);

  useEffect(() => {
    dispatch(getMyOrderDetail({ url: '/v1/mypage/orders', params: detailId }));
  }, [dispatch, detailId]);

  const openReceipt = () => {
    dispatch(
      openModal({
        body: (
          <PurchaseReceipt
            orderDetail={orderDetail}
            userName={userInfo?.name}
          />
        ),
      }),
    );
  };

  return (
    <section>
      {/* 주문 목록으로 이동 버튼 */}
      <Buttons
        variant="text"
        color="purple5"
        type="text"
        onClick={() => clickHandler()}
        className="mb-6 mt-8 flex items-center justify-start"
      >
        <img
          className="h-6"
          src={process.env.PUBLIC_URL + '/svg/icon-arrow-left-purple.svg'}
          alt="Calendar"
        />
        <TextWinds type="button2" color="purple5">
          주문 목록으로 이동
        </TextWinds>
      </Buttons>

      {/* 타이틀 */}
      <div className="mb-6 block">
        <TextWinds type="title_h2">구매 내역 상세</TextWinds>
      </div>

      {/* 주문 정보 */}
      <div className="flex flex-col gap-y-6 lg:gap-y-4">
        {orderDetail && <OrderInfo orderDetail={orderDetail} />}
        {orderDetail && <OrderIteminfo orderDetail={orderDetail} />}
        {orderDetail && <PaymentDetail orderDetail={orderDetail} />}
        {orderDetail?.status === 'REFUND_COMPLETE' && (
          <RefundCancelInfo orderDetail={orderDetail} />
        )}
        {orderDetail && <DeliveryInfo orderDetail={orderDetail} />}
      </div>

      {/* INFO: 현재 영수증 기획은 거래명세서에 가까워서 결제 수단 표출 없음. 
      결제 상태가 PAY_RECIEVED(결제 완료) 또는 COMPLETE(구매 완료)인 경우에만 영수증 출력 버튼 표시. 
      영수증 기획 변경 시 영수증 개선, 모든 결제 상태에 대해 영수증 출력 가능하도록 수정 필요 */}
      {(orderDetail?.status === 'PAY_RECIEVED' ||
        orderDetail?.status === 'COMPLETE') && (
        <Buttons
          variant="outlined"
          color="purple5"
          onClick={() => openReceipt()}
          className="mt-16 lg:mt-6"
        >
          <TextWinds type="button" color="purple5">
            영수증 출력하기
          </TextWinds>
        </Buttons>
      )}
    </section>
  );
};

export default MypagePurchaseDetail;
